module.exports = __webpack_public_path__ + "img/icon53.14b96502.png";